import { Any, JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { MeetingDetailsInterface, OptimalSelectedProductInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('OptimalSelectedProduct')
export class OptimalSelectedProduct implements OptimalSelectedProductInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('ProductCode', IdAdapter, true)
    private _code: Id = undefined;

    @JsonProperty('Code', IdAdapter, true)
    private _encryptedCode: Id = undefined;

    @JsonProperty('ISIN', StringAdapter, true)
    private _isin: string = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Message', StringAdapter, true)
    private _message: string = undefined;

    @JsonProperty('IsAppropriateness', Boolean, true)
    private _isAppropriateness: boolean = undefined;

    @JsonProperty('IsAutomatic', Boolean, true)
    private _isAutomatic: boolean = undefined;

    @JsonProperty('OptimalClass', Boolean, true)
    private _isOptimal: boolean = undefined;

    @JsonProperty('Status', StringAdapter, true)
    private _status: string = undefined;

    get id(): Id {
        return this._id;
    }

    get code(): Id {
        return this._code;
    }

    get encryptedCode(): Id {
        return this._encryptedCode;
    }

    get isin(): string {
        return this._isin;
    }

    get name(): string {
        return this._name;
    }

    get message(): string {
        return this._message;
    }

    get isAppropriateness(): boolean {
        return this._isAppropriateness;
    }

    get isAutomatic(): boolean {
        return this._isAutomatic;
    }

    get isOptimal(): boolean {
        return this._isOptimal;
    }

    get status(): string {
        return this._status;
    }
}
